"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactSelect = require("react-select");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styled = require("./styled");
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _reactI18next = require("react-i18next");
var _react = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const selectFirst = (_ref, filter) => {
  let {
    label
  } = _ref;
  return label.toUpperCase().indexOf(filter.toUpperCase()) === 0;
};
const SelectSeach = _ref2 => {
  var _selectOptions$find;
  let {
    allowNone = false,
    align = 'left',
    asyncLoad = false,
    customControl,
    customOption,
    disableInputFilter = false,
    disabled,
    flex = 'none',
    fontSize = '11px',
    hasError,
    height = '40px',
    hideSelectedOptions = true,
    loading,
    margin,
    maxMenuHeight,
    noOptionsText = '',
    objectChange = false,
    onChange = () => null,
    onInputChange = () => null,
    onlyPlaceholder = false,
    options = [],
    menuPlacement = 'bottom',
    placeholder,
    searchStart,
    value,
    width = '150px'
  } = _ref2;
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const handleChange = item => {
    if (objectChange) {
      onChange(item);
    } else {
      const {
        value
      } = item;
      onChange(value);
    }
  };
  const handleInputChange = value => {
    onInputChange(value);
  };
  const Control = (0, _react.useMemo)(() => {
    if (!customControl) return undefined;
    return props => /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactSelect.components.Control, _objectSpread(_objectSpread({}, props), {}, {
      children: customControl(props)
    }));
  }, [customControl]);
  const Option = (0, _react.useMemo)(() => {
    if (!customOption) return undefined;
    return props => /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactSelect.components.Option, _objectSpread(_objectSpread({}, props), {}, {
      children: customOption(props)
    }));
  }, [customOption]);
  const selectOptions = allowNone || onlyPlaceholder && !value ? [{
    label: placeholder !== null && placeholder !== void 0 ? placeholder : t('Cualquiera'),
    value: 0
  }, ...options] : options;
  const currentValue = (_selectOptions$find = selectOptions.find(_ref3 => {
    let {
      value: itemValue
    } = _ref3;
    return itemValue === value;
  })) !== null && _selectOptions$find !== void 0 ? _selectOptions$find : {
    label: placeholder !== null && placeholder !== void 0 ? placeholder : t('Cualquiera'),
    value: 0
  };
  const selectProps = {
    align,
    components: _objectSpread(_objectSpread({}, Control ? {
      Control
    } : {}), Option ? {
      Option
    } : {}),
    flex,
    fontSize,
    hasError,
    height,
    hideSelectedOptions,
    margin,
    maxMenuHeight,
    menuPlacement,
    placeholder,
    width
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.StyledSelect, _objectSpread(_objectSpread({}, selectProps), {}, {
    classNamePrefix: "react-select",
    filterOption: disableInputFilter ? () => true : !searchStart ? undefined : selectFirst,
    isDisabled: disabled || (0, _isEmpty.default)(options) && !asyncLoad,
    isLoading: loading,
    isMulti: false,
    isSearchable: true,
    loadingMessage: () => t('Cargando...'),
    noOptionsMessage: () => noOptionsText !== null && noOptionsText !== void 0 ? noOptionsText : t('No hay opciones disponibles'),
    options: selectOptions,
    value: currentValue,
    onChange: handleChange,
    onInputChange: handleInputChange
  }));
};
SelectSeach.propTypes = {
  align: _propTypes.default.oneOf(['center', 'left']),
  allowNone: _propTypes.default.bool,
  asyncLoad: _propTypes.default.bool,
  customControl: _propTypes.default.func,
  customOption: _propTypes.default.func,
  disabled: _propTypes.default.bool,
  disableInputFilter: _propTypes.default.bool,
  flex: _propTypes.default.string,
  fontSize: _propTypes.default.string,
  hasError: _propTypes.default.bool,
  height: _propTypes.default.string,
  hideSelectedOptions: _propTypes.default.bool,
  loading: _propTypes.default.bool,
  margin: _propTypes.default.string,
  maxMenuHeight: _propTypes.default.number,
  menuPlacement: _propTypes.default.oneOf(['auto', 'bottom', 'top']),
  noOptionsText: _propTypes.default.string,
  objectChange: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  onInputChange: _propTypes.default.func,
  onlyPlaceholder: _propTypes.default.bool,
  options: _propTypes.default.array,
  placeholder: _propTypes.default.string,
  searchStart: _propTypes.default.bool,
  value: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  width: _propTypes.default.string
};
var _default = exports.default = SelectSeach;